import { render, staticRenderFns } from "./ButtonRed.vue?vue&type=template&id=67eeded4&"
import script from "./ButtonRed.vue?vue&type=script&lang=js&"
export * from "./ButtonRed.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRed.vue?vue&type=style&index=0&id=67eeded4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports